module.exports = __webpack_public_path__ + "static/media/login_logo.c28e0894.png";